import React, { memo, useMemo } from 'react';

import { AccordionButtonProps } from '@chakra-ui/accordion';
import { CustomAccordionButton } from './styles';

import * as numbersPng from 'constants/numberImages';
import { Box } from '@chakra-ui/layout';
import { CustomIcon } from 'components';

interface IProps extends AccordionButtonProps {
  index: Number;
  // changeIndex: Function;
}

const AccordionHeaderComponent: React.FC<IProps> = ({ children, index, ...props }) => {
  const key = useMemo(() => `image${index}` as keyof typeof numbersPng, [index]);
  return (
    <CustomAccordionButton
      {...props}
      _focus={{ boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)' }}
      color="brand.900"
    >
      {/* <p>{index}</p> */}
      <Box mr="8px" as="img" width="32px" height="32px" src={numbersPng[key]} />
      {children}
      {/* <AccordionIcon ml="auto" color="brand.900" /> */}
      <Box ml="auto">
        <CustomIcon
          className="icon"
          $noSphere
          icon="chevron_down"
          size="24px"
          color="brand.primary"
        />
      </Box>
    </CustomAccordionButton>
  );
};

export const AccordionHeader = memo(AccordionHeaderComponent);
